import React from "react";
import "./RepairVehicle.scss";
import Grid from "@mui/material/Unstable_Grid2";

function RepairVehicle() {
  const repairlist = [
    {
      image_url: "./images/repairservice_icon.svg",
      title: "Quick Repair Services",
    },
    {
      image_url: "./images/experienced_mechanic_icon.svg",
      title: "Experienced Mechanics",
    },
    {
      image_url: "./images/advance_repair_icon.svg",
      title: "Advance Repair Tools",
    },
  ];

  const services_list = [
    {
      title: "Periodic Services",
    },
    {
      title: "AC Service / Repair",
    },
    {
      title: "Batteries",
    },
    {
      title: "Tyre & Wheel Care",
    },
    {
      title: "Denting & Painting",
    },
    {
      title: "Detailling Services",
    },
    {
      title: "Car Spa & Cleaning",
    },
    {
      title: "Car Inspections",
    },
    {
      title: "Windshields & Lights",
    },
    {
      title: "Suspension & Fitments",
    },
    {
      title: "Clutch & Body Parts",
    },
  ];
  return (
    <Grid xs className="repairVehicle_wrapper">
      <Grid container spacing={3}>
        <Grid xs={8}>
          <div className="main_heading mb-10">
            <h5>
              Repair <span>Vehicle</span>
            </h5>
            <p>Mechanical services for your vehicle</p>
          </div>

          <div className="repair_list">
            <ul className="inner_repairlist">
              {repairlist.map((data, index) => (
                <li>
                  <div className="inner_content">
                    <img src={data.image_url} />
                  </div>
                  {data.title}
                </li>
              ))}
            </ul>
          </div>
        </Grid>
        <Grid xs={4}>
          <div className="main_heading mb-5">
            <h5>Services</h5>
            <p>Offer something more than your average garage</p>
          </div>

          <div className="services">
            <ul className="services_list">
              {services_list.map((data, index) => (
                <>
                  <li>
                    <img src="./images/repair_service_icon.svg" alt="" />
                    {data.title}
                  </li>
                  {index != services_list.length - 1 && <hr />}
                </>
              ))}
            </ul>
          </div>
        </Grid>
      </Grid>
    </Grid>
  );
}

export default RepairVehicle;
